import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 minute
      retry: 1,
    },
  },
});

interface WithQueryProps {
  children: React.ReactNode;
}

export default function WithQuery({ children }: WithQueryProps) {
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
